export default "__VITE_ASSET__DOUX_WOR__"